import { useMemo, type ReactNode } from 'react';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ToastProvider } from '@/components/Toast';
import {
  createLocalStorageAssetRepository,
  createLocalStorageCategoryRepository,
} from '@/lib/localStorageRepositories';

import { RepositoryProvider, type Repositories } from './repositoryContext';

const AppProviders = ({ children }: { children: ReactNode }) => {
  const repositories = useMemo<Repositories>(
    () => ({
      assets: createLocalStorageAssetRepository(),
      categories: createLocalStorageCategoryRepository(),
    }),
    [],
  );

  return (
    <ErrorBoundary>
      <ToastProvider>
        <RepositoryProvider value={repositories}>{children}</RepositoryProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
};

export default AppProviders;
